// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul.spotlight-result[data-v-4dfe48c5] {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nul.spotlight-result > li[data-v-4dfe48c5] {\r\n  margin-bottom: 10px;\n}\n.app-link[data-v-4dfe48c5] {\r\n  padding: 0 !important;\r\n  height: auto !important;\n}\n.app-link.v-btn[data-v-4dfe48c5]:hover::before,\r\n.app-link.v-btn[data-v-4dfe48c5]:focus::before{\r\n  background-color: transparent !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
